import { AxiosResponse } from "axios";
import { getRequest } from "../commonActions/get";
import { Requests } from "../../config/api";
import { postRequest } from "../commonActions/post";
import { CreatePackageOptionsProps } from "../../declarations/tourServices";
import { deleteRequest } from "../commonActions/delete";
import { PackageOptionsProps } from "../../types/data";
import { putRequest } from "../commonActions/update";

export const GetOptions = async (query: any) => {
  try {
    const id = query.id;

    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getOptionById}/${id}?page=1&limit=10`,
    });
    // const response: AxiosResponse = await getRequest({
    //   route: `${Requests.get.getAllOptions}/?page=1&limit=10`,
    // });

    const options = response?.data?.options || [];
    const status = response?.status || 500;
    const message = response?.data?.message || "No message provided";
    const errors = response?.data?.errors || [];

    return {
      status,
      options,
      errors,
      message,
    };
  } catch (error) {
    console.error("Error in GetOptions API call:", error);
    throw error;
  }
};

export const GetOptionsById = async (id: string) => {};

export const CreateOptions = async (payload: PackageOptionsProps) => {
  try {
    const response: AxiosResponse = await postRequest({
      route: `${Requests.post.createOption}`,
      payload,
    });

    const status = response?.status || 500;
    const message = response?.data?.message || "No message provided";
    const errors = response?.data?.errors || [];

    return {
      status,
      errors,
      message,
    };
  } catch (error) {
    console.error("Error in CreateOptions API call:", error);
    throw error;
  }
};

export const DeleteOptions = async (id: string) => {
  try {
    const response: AxiosResponse = await deleteRequest({
      route: `${Requests.delete.deleteOption}/${id}`,
    });

    const status = response?.status || 500;
    const message = response?.data?.message || "No message provided";
    const errors = response?.data?.errors || [];

    return {
      status,
      errors,
      message,
    };
  } catch (error) {
    console.error("Error in DeleteOptions API call:", error);
    throw error;
  }
};

export const CreatePreOptions = async (payload: PackageOptionsProps) => {
  try {
    const response: AxiosResponse = await postRequest({
      route: `${Requests.post.createPreOptions}`,
      payload,
    });

    const status = response?.status || 500;
    const message = response?.data?.message || "No message provided";
    const errors = response?.data?.errors || [];

    return {
      status,
      errors,
      message,
    };
  } catch (error) {
    console.error("Error in CreatePreOptions API call:", error);
    throw error;
  }
};

export const UpdateOption = async ({
  id,
  payload,
}: {
  id: string;
  payload: any;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await putRequest({
      route: `${Requests.update.updateOption}${id}`,
      payload: payload,
    });

    const status = response?.status;
    const errors = response?.data?.errors;
    const message = response?.data?.message;

    return {
      status,
      errors,
      message,
    };
  } catch (error) {
    throw error;
  }
};
